<div nxLayout="grid maxwidth" class="profile" *ngIf="this.isReady | async">
    <div nxRow>
        <div nxCol="12">
            <section class="nx-margin-bottom-3m">
                <h3 nxHeadline="subsection-large" class="nx-margin-bottom-s" translate>profile.texts.my-profile</h3>
                <cpc-panel-group>
                    <cpc-panel>
                        <div class="panel">
                            <ng-container [ngTemplateOutlet]="accountDataHeader"></ng-container>
                            <ng-container [ngTemplateOutlet]="acountDataContent"></ng-container>
                        </div>
                    </cpc-panel>
                </cpc-panel-group>
            </section>
            <section>
                <cpc-panel-group>
                    <cpc-panel *ngIf="this.profileEk">
                        <div class="panel panel__no-bottom-padding">
                            <section class="nx-margin-bottom-3m">
                                <div nxLayout="grid nopaddings">
                                    <div nxRow class="no-margins">
                                        <div nxCol="12" class="panel-header">
                                            <h2 nxHeadline="subsection-medium" class="nx-font-weight-semibold"
                                                translate>
                                                profile.texts.account-settings
                                            </h2>
                                        </div>
                                        <div nxCol="12" class="panel-content">
                                            <div class="profile-settings">
                                                <div class="profile-settings__row">
                                                    <div class="profile-settings__item">
                                                        <div class="label" translate>profile.texts.password</div>
                                                        <div class="value"> *********
                                                            {{ 'profile.texts.password-last-change' | translate : { 'date': this.profile.passwordLastChange | dateFormat } }}
                                                        </div>
                                                    </div>
                                                    <div class="profile-settings__action">
                                                        <nx-link>
                                                            <a href="javascript:void(0)"
                                                                (click)="openModal('PasswordChange')">
                                                                <nx-icon name="arrow-right" nxIconPositionStart
                                                                    aria-hidden="true"></nx-icon>
                                                                <span translate>profile.texts.change</span>&nbsp;
                                                            </a>
                                                        </nx-link>
                                                    </div>
                                                </div>
                                                <div class="profile-settings__row">
                                                    <div class="profile-settings__item">
                                                        <div class="label" translate>profile.texts.terminate-account
                                                        </div>
                                                        <div class="value"></div>
                                                    </div>
                                                    <div class="profile-settings__action">
                                                        <nx-link>
                                                            <a href="javascript:void(0)"
                                                                (click)="openModal('AccountCancel')">
                                                                <nx-icon name="arrow-right" nxIconPositionStart
                                                                    aria-hidden="true"></nx-icon>
                                                                <span translate>profile.texts.delete</span>&nbsp;
                                                            </a>
                                                        </nx-link>
                                                    </div>
                                                </div>
                                                <div class="profile-settings__row">
                                                    <div class="profile-settings__item">
                                                        <div class="label" translate>
                                                            profile.texts.payment-notifications
                                                            <button nxIconButton="tertiary small"
                                                                [nxPopoverTriggerFor]="popoverNotifications"
                                                                nxPopoverTrigger="click" type="button"
                                                                class="nx-popover__button nx-margin-right-3xs">
                                                                <nx-icon name="info-circle-o" size="s"
                                                                    aria-hidden="true">
                                                                </nx-icon>
                                                            </button>
                                                            <nx-popover #popoverNotifications>
                                                                <div
                                                                    class="nx-popover__content-wrapper popover-profile">
                                                                    <h3 nxHeadline="subsection-small"
                                                                        class="nx-margin-bottom-s" translate>
                                                                        profile.texts.payment-notifications-popover-title
                                                                    </h3>
                                                                    <p class="nx-margin-bottom-m" translate>
                                                                        profile.texts.payment-notifications-popover-content
                                                                    </p>
                                                                </div>
                                                            </nx-popover>
                                                        </div>
                                                        <div class="value" translate>

                                                        </div>
                                                    </div>
                                                    <div class="profile-settings__action">
                                                        <form [formGroup]="formNotifications">
                                                            <nx-switcher
                                                                formControlName="enabledNotifications"></nx-switcher>
                                                        </form>
                                                    </div>
                                                </div>
                                                <div class="profile-settings__row">
                                                    <div class="profile-settings__item">
                                                        <div class="label" translate>profile.texts.my-preferred-agent
                                                        </div>
                                                        <div class="value" translate>{{ this.getPreferredAgentName() }}
                                                        </div>
                                                    </div>
                                                    <div class="profile-settings__action">
                                                        <nx-link>
                                                            <a href="javascript:void(0)"
                                                                (click)="openModal('PreferredAgent')">
                                                                <nx-icon name="arrow-right" nxIconPositionStart
                                                                    aria-hidden="true"></nx-icon>
                                                                <span translate>profile.texts.details</span>&nbsp;
                                                            </a>
                                                        </nx-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section>
                                <div nxLayout="grid nopaddings">
                                    <div nxRow class="no-margins">
                                        <div nxCol="12" class="panel-header">
                                            <h2 nxHeadline="subsection-medium" class="nx-font-weight-semibold"
                                                translate>
                                                profile.texts.consent-and-declarations
                                            </h2>
                                        </div>
                                    </div>
                                    <div nxCol="12" class="panel-content">
                                        <div class="profile-settings">
                                            <ng-container [ngTemplateOutlet]="ecCheckbox"
                                                *ngIf="!ecAgreementChecked"></ng-container>
                                            <ng-container [ngTemplateOutlet]="mkCheckbox"
                                                *ngIf="!mktChecked"></ng-container>
                                            <nx-link *ngIf="!isShowedCheckboxes && (ecAgreementChecked || mktChecked)">
                                                <a href="javascript:void(0)" (click)="showConsents()">
                                                    <span translate>profile.texts.show-all-consents</span>&nbsp;
                                                    <nx-icon name="chevron-down" nxIconPositionEnd
                                                        aria-hidden="true"></nx-icon>
                                                </a>
                                            </nx-link>

                                            <div class="consents-declarations" *ngIf="isShowedCheckboxes">
                                                <ng-container [ngTemplateOutlet]="ecCheckbox"
                                                    *ngIf="ecAgreementChecked"></ng-container>
                                                <ng-container [ngTemplateOutlet]="mkCheckbox"
                                                    *ngIf="mktChecked"></ng-container>
                                            </div>
                                        </div>
                                        <div class="illustration">
                                            <cpc-illustration [name]="'womanWithComputerDisplayingChecks'"
                                                [width]="'280px'"></cpc-illustration>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </cpc-panel>
                </cpc-panel-group>
            </section>
        </div>
    </div>
</div>
<app-help page="my-profile"></app-help>
<app-preffered-agent></app-preffered-agent>


<ng-template #ecCheckbox>
    <nx-checkbox class="nx-margin-bottom-s" [disabled]="this.isDisabledChanges || this.profile.email.length == 0"
        (checkedChange)="changeEcAgreement($event)" [(checked)]="ecAgreementChecked">
        <span translate>profile.texts.ec-agreement</span>
        <button nxIconButton="tertiary small" [nxPopoverTriggerFor]="popoverEcAgreement" nxPopoverTrigger="click"
            type="button" class="nx-popover__button nx-margin-right-3xs">
            <nx-icon name="info-circle-o" size="s" aria-hidden="true">
            </nx-icon>
        </button>
        <nx-popover #popoverEcAgreement>
            <div class="nx-popover__content-wrapper popover-profile">
                <h3 nxHeadline="subsection-small" class="nx-margin-bottom-s" translate>
                    profile.texts.ec-agreement-popover-title
                </h3>
                <p class="nx-margin-bottom-m" [innerHTML]="'profile.texts.ec-agreement-popover-content' | translate">
                </p>
            </div>
        </nx-popover>
        <br />
        <nx-link *ngIf="ecAgreementChecked">
            <a href="javascript:void(0)" *ngIf="isDisabledChanges" disabled>
                <nx-icon name="arrow-right" nxIconPositionStart aria-hidden="true"></nx-icon>
                <span translate>profile.texts.ec-password-change</span>&nbsp;
            </a>
            <a href="javascript:void(0)" *ngIf="!isDisabledChanges" (click)="openModal('PasswordChangeEc')">
                <nx-icon name="arrow-right" nxIconPositionStart aria-hidden="true"></nx-icon>
                <span translate>profile.texts.ec-password-change</span>&nbsp;
            </a>
        </nx-link>
    </nx-checkbox>
</ng-template>


<ng-template #mkCheckbox>
    <nx-checkbox class="nx-margin-bottom-s" (checkedChange)="changeMktApproval($event)" [(checked)]="mktChecked">
        <span translate>profile.texts.marketing-agreement</span>
        <button nxIconButton="tertiary small" [nxPopoverTriggerFor]="popoverMarketing" nxPopoverTrigger="click"
            type="button" class="nx-popover__button nx-margin-right-3xs">
            <nx-icon name="info-circle-o" size="s" aria-hidden="true">
            </nx-icon>
        </button>
        <nx-popover #popoverMarketing>
            <div class="nx-popover__content-wrapper popover-profile">
                <h3 nxHeadline="subsection-small" class="nx-margin-bottom-s" translate>
                    profile.texts.marketing-agreement-popover-title
                </h3>
                <p class="nx-margin-bottom-m"
                    [innerHTML]="'profile.texts.marketing-agreement-popover-content' | translate">

                </p>
            </div>
        </nx-popover>
    </nx-checkbox>
</ng-template>


<ng-template #accountDataHeader>
    <div nxLayout="grid nopaddings">
        <div nxRow class="no-margins">
            <div nxCol="12" class="panel-header panel-header__margin nx-margin-bottom-m">
                <h2 nxHeadline="subsection-medium" class="nx-font-weight-semibold" translate>profile.texts.personal-data
                </h2>
                <nx-link nxStyle="block">
                    <a routerLink="/moj-profil/editacia" *ngIf="!isDisabledChanges">
                        <nx-icon name="edit" aria-hidden="true"></nx-icon>
                        <em translate>profile.texts.edit</em>
                    </a>
                    <a routerLink="/moj-profil/editacia" *ngIf="isDisabledChanges" disabled>
                        <nx-icon name="edit" aria-hidden="true"></nx-icon>
                        <em translate>profile.texts.edit</em>
                    </a>
                </nx-link>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #acountDataContent>
    <div nxLayout="grid nopaddings">
        <div nxRow>
            <div nxCol="12" class="panel-content">
                <div class="profile-photo">
                    <img src="assets/images/user-icon.png" alt="">
                    <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m nx-font-weight-semibold">
                        {{ this.profile.firstName }} {{ this.profile.lastName }}
                    </h3>
                </div>
                <div class="profile-data">
                    <div class="profile-data__name">
                        <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m nx-font-weight-semibold">
                            {{ this.profile.firstName }} {{ this.profile.lastName }}</h3>
                    </div>
                    <div class="profile-data__account" *ngIf="this.profile">
                        <div nxLayout="grid nopaddings">
                            <div nxRow class="no-margins">
                                <div nxCol="12,12,6,6,3" class="no-paddings column">
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.date-of-birth</span>
                                        <span content
                                            class="nx-font-weight-semibold">{{ this.profile.dateOfBirth | dateFormat }}
                                        </span>
                                    </profile-entry>
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.id-card</span>
                                        <span content
                                            class="nx-font-weight-semibold">{{ this.profile.identityCard.value }}</span>
                                    </profile-entry>
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.valid-to</span>
                                        <span content
                                            class="nx-font-weight-semibold">{{ this.profile.identityCard.validTo | dateFormat }}</span>
                                    </profile-entry>
                                </div>
                                <div nxCol="12,12,6,6,5" class="no-paddings column">
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.email-address</span>
                                        <span content class="nx-font-weight-semibold">{{ this.profile.email }}</span>
                                    </profile-entry>
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.mobile</span>
                                        <span content class="nx-font-weight-semibold">{{ this.profile.mobile }}</span>
                                    </profile-entry>
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.id-number</span>
                                        <span content class="nx-font-weight-semibold">{{ this.profile.idNumber }}</span>
                                    </profile-entry>
                                </div>
                                <div nxCol="12,12,12,12,4" class="no-paddings column">
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.address</span>
                                        <span content
                                            class="nx-font-weight-semibold">{{ formatAddress(this.profile.address) }}</span>
                                    </profile-entry>
                                    <profile-entry class="nx-margin-bottom-s">
                                        <span title translate>profile.texts.my-allianz-access</span>
                                        <span content
                                            class="nx-font-weight-semibold">{{ getAccessText() | translate }}</span>
                                    </profile-entry>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>